import { ApiError } from '@/lib/api';

interface ErrorAlertProps {
  error: unknown;
  className?: string;
}

/**
 * Einheitliche Fehler-Darstellung: zieht status + detail aus ApiError,
 * fällt für plain Error auf message zurück. Wird in allen Listen
 * eingesetzt (Konsistenz > DRY).
 */
export function ErrorAlert({ error, className }: ErrorAlertProps): JSX.Element {
  let title = 'Fehler';
  let detail = '';
  let resolution: string | undefined;

  if (error instanceof ApiError) {
    title = `Fehler ${error.status}: ${error.problem?.title ?? error.message}`;
    detail = error.problem?.detail ?? '';
    resolution = error.problem?.resolution;
  } else if (error instanceof Error) {
    detail = error.message;
  } else {
    detail = String(error);
  }

  return (
    <div
      role="alert"
      className={[
        'rounded-md border border-danger/30 bg-danger/5 p-3 text-sm text-danger',
        className ?? '',
      ].join(' ')}
    >
      <p className="font-medium">{title}</p>
      {detail && <p className="mt-1 text-danger/90">{detail}</p>}
      {resolution && <p className="mt-1 text-xs text-danger/80">Loesung: {resolution}</p>}
    </div>
  );
}
